import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Item } from '../../admin/models/item';
import { ShoppingService } from '../services/shopping.service';
import { AlertService } from 'app/shared/services/alert.service';
import { Router, ActivatedRoute, OutletContext } from '@angular/router';
import {debounce} from "lodash";

@Component({
  selector: 'dac-buy-item-button',
  templateUrl: './buy-item-button.component.html',
  styleUrls: ['./buy-item-button.component.scss']
})
export class BuyItemButtonComponent implements OnInit {

  @Input() item:{uid?:string, id?:number, name:string};
  @Output() click = new EventEmitter<{uid?:string, id?:number, name:string}>();
  public buying:boolean;
  
  constructor(private shoppingService:ShoppingService
    , private alertService:AlertService
    , private router:Router
    , private activeRoute:ActivatedRoute) { }

  ngOnInit() {
  }

  public buyItem(event:Event) {
    event.stopPropagation();
    event.preventDefault();
    
    // let listener's know we were clicked with our item.
    this.click.emit(this.item);

    let alert = this.alertService.info("Adding " + this.item + " to shopping cart");
    this.buying = true;
    let shoppingItem;
    if (this.item.uid) {
      shoppingItem = this.shoppingService.getItemForAssessment({uid: this.item.uid});
    }
    else {
      shoppingItem = this.shoppingService.getItemForAssessmentGroup({id: this.item.id, name: this.item.name});
    }

    shoppingItem.then(i => {
      this.alertService.clearAlert(alert);
      alert = null;
      i.quantity = 1; // make sure we have at least one item to add.
      return this.shoppingService.addItemToCart(i);
    })
    .then(() => {
      this.buying = false;
      this.shoppingService.startSingleCheckoutOrder(this.router.url);
      this.router.navigateByUrl('/admin/shop/checkout');
    })
    .catch(error => {
      this.buying = false;
      console.error(error);
      if (alert) {
        this.alertService.clearAlert(alert);
      }
      this.alertService.error("There was an error in attempting to purchase this item.  Please try again or contact support");
    });  
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/buy-item-button/buy-item-button.component.ts